import { render, staticRenderFns } from "./PeriodSelector.vue?vue&type=template&id=2d4faa1a&scoped=true&lang=pug&"
import script from "./PeriodSelector.vue?vue&type=script&lang=ts&"
export * from "./PeriodSelector.vue?vue&type=script&lang=ts&"
import style0 from "./PeriodSelector.vue?vue&type=style&index=0&id=2d4faa1a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4faa1a",
  null
  
)

export default component.exports